import { useState } from 'react';

import Button from '~/common/componentMapper/Button/Button';
import Text from '~/common/componentMapper/Text/Text';
import Stack from '~/common/components/Stacks/Stack';

import { SHOW_LESS, SHOW_MORE } from '../constants';

type DetailedAnswerProps = {
  detailedAnswer?: string;
};

const DetailedAnswer = ({ detailedAnswer }: Readonly<DetailedAnswerProps>) => {
  const [detailedAnswerStyle, setDetailedAnswerStyle] = useState({
    overflow: false,
    whiteSpace: false,
    maxWidth: false,
    showMore: false,
  });
  const { overflow, whiteSpace, maxWidth, showMore } = detailedAnswerStyle;
  const hasEllipsis = (detailedAnswer?.split('')?.length ?? 0) > 50;

  const handleDetailedAnswerStyles = () => {
    setDetailedAnswerStyle((prev) => {
      return {
        ...prev,
        overflow: !prev.overflow,
        whiteSpace: !prev.whiteSpace,
        maxWidth: !prev.maxWidth,
        showMore: !prev.showMore,
      };
    });
  };
  return (
    <>
      <Text
        sx={{
          whiteSpace: whiteSpace ? 'wrap' : 'nowrap',
          overflow: overflow ? 'visible' : 'hidden',
          textOverflow: hasEllipsis && 'ellipsis',
          maxWidth: maxWidth ? 'auto' : '550px',
          paddingRight: '1rem',
        }}
        text={detailedAnswer}
      />
      <Stack
        direction="row"
        sx={{ justifyContent: 'flex-end', marginRight: '1rem' }}
      >
        {hasEllipsis && (
          <Button
            type="linkButton"
            name="showMore"
            label={showMore ? SHOW_LESS : SHOW_MORE}
            onClick={() => handleDetailedAnswerStyles()}
          />
        )}
      </Stack>
    </>
  );
};

export default DetailedAnswer;
